package data.objects.views

import apiclient.geoobjects.GeoObjectDetails
import apiclient.geoobjects.ObjectType
import data.objects.ActiveObjectStore
import data.users.views.profileInput
import dev.fritz2.core.RenderContext
import koin.koinCtx
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.map
import localization.TL
import localization.Translation
import localization.translate
import model.L
import model.ScannedCode
import model.extObjId
import model.type
import qrcode.ScannedCodeStore
import twcomponents.twColOfNoGap
import twcomponents.twPageHeaderClose
import twcomponents.twPrimaryButton
import twcomponents.twSubtitle
import twcomponents.twTitle
import utils.focusInputObserver
import utils.getIcon
import utils.getName
import utils.handleFunctions
import webcomponents.baseLayout
import webcomponents.twContentScrollBox

fun RenderContext.cardCreate(type: ObjectType) {
    val translation: Translation by koinCtx.inject()

    val activeObjectStore: ActiveObjectStore by koinCtx.inject()
    val scannedCodeStore: ScannedCodeStore by koinCtx.inject()
    val objectType = activeObjectStore.map(GeoObjectDetails.L.objectType)
    val title = activeObjectStore.map(GeoObjectDetails.L.title)
    val scannedCode = scannedCodeStore.map(ScannedCode.extObjId()).data.map { it ?: "" }
    val codeIcon = scannedCodeStore.map(ScannedCode.type()).data.map { it?.getIcon() }
    val titlePlaceholder: Flow<String> = when (type) {
        ObjectType.POI -> translation[TL.CardCreate.POI_PLACEHOLDER]
        ObjectType.Task -> translation[TL.CardCreate.TASK_PLACEHOLDER]
        ObjectType.Event -> translation[TL.CardCreate.MEETING_PLACEHOLDER]
        ObjectType.Zone -> translation[TL.CardCreate.ZONE_PLACEHOLDER]
        ObjectType.ObjectMarker -> translation[TL.CardCreate.TRACKED_OBJECT_PLACEHOLDER]
        else -> flowOf("Name")
    }

    flowOf(type) handledBy objectType.update

    baseLayout(
        header = {
            twPageHeaderClose(
                backButtonTitle = TL.General.CANCEL,
                additionalBackButtonHandler = handleFunctions {
                    activeObjectStore.resetStore(Unit)
                },
            ) {
                twColOfNoGap("w-full") {
                    twTitle {
                        translate(TL.CardCreate.CREATE_NEW, mapOf("objectType" to type.getName()))
                    }
                    if (type == ObjectType.ObjectMarker) {
                        codeIcon.render { icon ->
                            twSubtitle(icon = icon) {
                                scannedCode.renderText()
                            }
                        }
                    }
                }
            }
        },
        content = {
            twContentScrollBox("gap-2") {
                // TITLE INPUT
                profileInput(
                    id = "createTitleField",
                    titleAsFlow = titlePlaceholder,
                    icon = type.getIcon(),
                    placeHolder = titlePlaceholder,
                    store = title,
                    autofocus = true,
                )
                // Observer to set autofocus on title input field, when not on mobile
                focusInputObserver({ js("document.getElementById('createTitleField').focus()") }, domNode)

                // CREATE BUTTON
                twPrimaryButton(
                    text = TL.General.CREATE,
                    disabledFlow = title.data.map { it.isBlank() },
                ) {
                    className("mt-2")
                    clicks handledBy activeObjectStore.createNew
                }
            }
        },
    )
}
